import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthService } from '../../authentication/auth.service';
import { ApiServiceBase } from '../../base/api-service-base';
import { ExchangeRateGroupModel } from '../../models/reference-model/reference-general-model';

@Injectable({
    providedIn: 'root'
})
export class ExchangeRateGroupService extends ApiServiceBase {
    private readonly PATH = '/system/exchangerategroups';

    constructor(httpClient: HttpClient,
        authService: AuthService) {
        super(httpClient, authService);
    }

    public getAll(): Observable<ExchangeRateGroupModel[]> {
        return this.httpGet<ExchangeRateGroupModel[]>(this.PATH, null)
            .pipe(
                map(
                    res => res.body
                )
            )
    }
}
